export default __webpack_public_path__ + "static/media/logo-A-orbits-vector.9182479f.png";